import { create } from 'zustand'

export interface PrecomputedFrame {
    timestamp: number;
    marketData: any;
    analysis: any;
    maxValues: any;
    atmStrike: number;
    filteredOptions: any[];
    baseOptions: any[];
    baseSpot: number;
    baseTimestamp: number;
    mode: 'OI' | 'VOLUME';
    _phase: 'computed';
}

interface PrecomputedState {
    timelines: Record<string, PrecomputedFrame[]>;
    isPrecomputing: boolean;
    precomputeProgress: number; // 0 to 100
    
    setTimeline: (key: string, frames: PrecomputedFrame[]) => void;
    setIsPrecomputing: (isPrecomputing: boolean) => void;
    setProgress: (progress: number) => void;
    clearCache: () => void;
}

export const usePrecomputedStore = create<PrecomputedState>((set) => ({
    timelines: {},
    isPrecomputing: false,
    precomputeProgress: 0,
    
    setTimeline: (key, frames) => set((state) => ({ 
        timelines: { ...state.timelines, [key]: frames },
        isPrecomputing: false,
        precomputeProgress: 100
    })),
    
    setIsPrecomputing: (isPrecomputing) => set({ isPrecomputing }),
    
    setProgress: (precomputeProgress) => set({ precomputeProgress }),
    
    clearCache: () => set({ timelines: {}, precomputeProgress: 0 })
}));
